import { useEffect, useRef } from "react";
import Paragraph from "../paragraph";
import BgIcon from "../icons/bg-icon";

const Modal = ({
  isOpen,
  onClose,
  children,
  title,
  className,
  titleClass,
  contentClass,
  closeOnOutsideClick = true,
  showTitle = true,
  IconclassName = "",
  overlayClassName = "",
  overlayStyle,
  modalStyle,
}) => {
  const modalRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (closeOnOutsideClick && modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 !z-[100] flex items-center justify-center bg-black bg-opacity-50 ${overlayClassName}`}
      style={overlayStyle}
      onMouseDown={handleOutsideClick}
    >
      <div
        ref={modalRef}
        className={`relative w-full sm:max-w-xl bg-white md:rounded-2xl shadow dark:bg-brownish_black dark:border dark:border-neutral-800 ${className}`}
        style={modalStyle}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {showTitle && (
          <div
            className={`flex items-center justify-between px-4 sm:px-5 py-3 border-b dark:border-neutral-800 border-gray-200 ${titleClass}`}
          >
            <Paragraph
              className={`dark:!text-dark_primary_label font-semibold grow ${titleClass}`}
            >
              {title}
            </Paragraph>
            <BgIcon
              icon={"akar-icons:cross"}
              IconclassName={`!w-4 !h-4`}
              className={IconclassName}
              onClick={onClose}
            />
          </div>
        )}

        <div
          className={`${contentClass} flex justify-between items-center flex-row p-5 sm:p-6`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
